import { PayloadAction } from '@reduxjs/toolkit';
import { config } from 'config';
import { useInjectReducer } from 'redux-injectors';
import { createSlice } from 'utils/@reduxjs/toolkit';
// Importing from `utils` makes them more type-safe
import { AppDrawerState } from './types';

const _userDTO = localStorage.getItem(config.localUserDTO) || '{}';
const userDTO = JSON.parse(_userDTO);

let userInSession = false;
let userName = '';
if (userDTO && userDTO.role) {
  userInSession = true;
  userName = userDTO.firstName + ' ' + userDTO.lastName;
} else {
  userInSession = false;
}

const initialState: AppDrawerState = {
  visibility: true,
  userInSession: userInSession,
  userName: userName,
  redirectUrl: '',
};

const slice = createSlice({
  name: 'appDrawerState',
  initialState,
  reducers: {
    changeVisibility(state, action: PayloadAction<boolean>) {
      state.visibility = action.payload;
    },
    hideAppDrawer(state, action: PayloadAction) {
      state.visibility = false;
    },
    changeUserInSession(state, action: PayloadAction<boolean>) {
      state.userInSession = action.payload;
    },
    changeUserName(state, action: PayloadAction<string>) {
      state.userName = action.payload;
    },
    changeRedirectUrl(state, action: PayloadAction<string>) {
      state.redirectUrl = action.payload;
    },
  },
});

/** * `actions` will be used to trigger change in the state from where ever you want */
export const { actions: appDrawerActions } = slice;

/** Let's turn this into a hook style usage.
 * This will inject the slice to redux store and return
 * actions in case you want to use in the component
 * */

export const useAppDrawerSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  return { actions: slice.actions };
};
